export const formatETA = (eta) => {
    const date = new Date(null);
    date.setSeconds(eta);
    const result = date.toISOString().slice(14, 19);

    return result;
};

export const actionTextFromProgress = (progress) => {
    let message = "";

    if (progress?.queued) {
        message = "In queue...";
        if (progress?.eta) {
            message += `(Pos: ${progress.eta})`;
        }
    } else {
        message = "Generating...";
        if (progress?.tiling) {
            message = "Assembling...";
        } else if (progress?.eta) {
            message += `(ETA: ${formatETA(progress.eta)})`;
        }
    }

    return message;
};